import * as React from 'react';
import { clsx } from 'clsx';
import { Caption } from '@cian/ui-kit';

import { INewbuildingsCompareActionRow, INewbuildingsCompareDataRow } from '../../../NewbuildingsComparePage';
import * as style from '../../style.css';
import { TableCell } from '../TableCell';

export interface ICompareRowProps {
  row: INewbuildingsCompareActionRow | INewbuildingsCompareDataRow;
  pinnedIndex: number | null;
  registerCell(id: string): (node: HTMLDivElement | null) => void;
}

export const CompareRow = ({ row, pinnedIndex, registerCell }: ICompareRowProps) => {
  if (row.kind === 'action') {
    return (
      <div className={style['full-row']} role="row">
        {row.content}
      </div>
    );
  }

  return (
    <>
      {row.title && (
        <div className={style['label-row']} role="row">
          <Caption color="text-secondary-default">{row.title}</Caption>
        </div>
      )}
      <div className={clsx(style['row'], !row.hideDivider && style['content-row'])} role="row">
        {row.cells.map((cell, cellIndex) => (
          <TableCell
            cellRef={registerCell(`${row.key}::${cellIndex}`)}
            key={cellIndex}
            pinned={cellIndex === pinnedIndex}
          >
            {cell}
          </TableCell>
        ))}
      </div>
    </>
  );
};
